export default __webpack_public_path__ + "static/media/Priyanka Dutta - 335_PRIYANKA DUTTA.9e5d91f4.jpeg";